import axios from 'axios';
import store from '../../store';

import {getCurrentLocale} from '../../utils/i18n';
import {currentEnv, isCnito} from '../../helpers';

export const baseURL = `https://cnapp-graph-ql${
    currentEnv !== 'prd' ? '.qa' : ''
}.dmti.cloud/`;

const api = axios.create({
    baseURL,
});

api.interceptors.request.use(config => {
    return config;
});

api.interceptors.response.use(
    response => {
        return response;
    },
    function(error) {
        return Promise.reject(error);
    },
);

export const graphqlQueryBuild = (
    type,
    fields,
    params = '',
    catalog = true,
    platform = true,
) => {
    const {config, user} = store.getState();

    let currentCatalog = user.jwtToken ? user.catalogTenant : null;

    if (!currentCatalog) {
        if (isCnito()) {
            currentCatalog =
                getCurrentLocale() === 'por' ? 'CNITO_BR' : 'CNITO_LATAM';
        } else {
            currentCatalog =
                getCurrentLocale() === 'por'
                    ? 'CNPLUS_LATAM_BR'
                    : 'CNPLUS_LATAM_LATAM';
        }
    }

    /* eslint-disable max-len */
    let query = `{
        ${type}(language: ${getCurrentLocale().toUpperCase()}${
        catalog ? `, catalog: ${currentCatalog}` : ''
    } ${
        platform
            ? `, platform: "${
                  config.catalog_settings && config.catalog_settings.platforms
                      ? config.catalog_settings.platforms[0]
                      : 'PCTV_DASH'
              }"`
            : ''
    }${params.length > 0 ? `, ${params}` : ''})
        {
            ${fields}
        }
    }`;
    /* eslint-enable max-len */

    return query;
};

export default api;
